import { Injectable } from '@angular/core';
import {
  ObservableSignal,
  toObservableSignal,
} from 'ngxtension/to-observable-signal';
import { BehaviorSubject, map } from 'rxjs';
import { BaseStore } from './base.store';

type State = {
  isShowPageModal: boolean;
};

/**
 * @name LayoutStore
 * @description 레이아웃 상태 관리
 * @returns {void}
 */
@Injectable({ providedIn: 'root' })
export class LayoutStore extends BaseStore<State> {
  layoutScrollEvent$ = new BehaviorSubject<HTMLElement | null>(null);

  /**
   * @name isShowPageModal$
   * @description 페이지 모달 표시 여부를 반환
   * @returns {ObservableSignal<boolean>}
   */
  readonly isShowPageModal$: ObservableSignal<boolean> =
    toObservableSignal<boolean>(
      this.state$.pipe(map((state) => state.isShowPageModal)),
    );

  constructor() {
    super({
      isShowPageModal: false,
    });
  }

  /**
   * @name setIsShowPageModal
   * @description 선택된 아동의 센터 목록을 설정합니다.
   * @param {boolean} isShowPageModal
   * @returns {void}
   */
  setIsShowPageModal(isShowPageModal: boolean): void {
    this.updateState({ isShowPageModal });
  }
}
